/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockFormats.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Block Formats
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, November 14, 2018 - 12:17:52 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      11/14/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    BLOCKFORMAT_LIST_CONTAINER_LOADED,
    BLOCKFORMAT_LIST_CONTAINER_UNLOADED,
    BLOCKFORMAT_LIST_TABLE_LOADED,
    BLOCKFORMAT_LIST_TABLE_UNLOADED,

    BLOCKFORMAT_SELECT_ROW,
    BLOCKFORMAT_ADD,
    BLOCKFORMAT_EDIT,
    BLOCKFORMAT_DELETE,
    BLOCKFORMAT_OPEN_WARNING,
    BLOCKFORMAT_CLOSE_WARNING,
    BLOCKFORMAT_DELETE_DISABLE,

    BLOCKFORMAT_EDIT_CONTAINER_LOADED,
    BLOCKFORMAT_EDIT_CONTAINER_UNLOADED,
    BLOCKFORMAT_EDIT_FORM_LOADED,
    BLOCKFORMAT_EDIT_FORM_UNLOADED,
    BLOCKFORMAT_EDIT_DATA_LOAD,
    BLOCKFORMAT_EDIT_CONTAINER_SUBMIT,
    BLOCKFORMAT_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockFormats';

const defaultState = {
    refreshList: false,
    danger: false,
    blockformatid: 0,
    name: '',
    description: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case BLOCKFORMAT_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockformats: action.payload[0] ? action.payload[0].records : null
            }
        case BLOCKFORMAT_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case BLOCKFORMAT_SELECT_ROW:
            return {
                ...state,
                blockformatid: action.id
            }
        case BLOCKFORMAT_ADD:
            return {
                ...state
            }
        case BLOCKFORMAT_EDIT:
            return {
                ...state,
                blockformatid: action.id
            }
        case BLOCKFORMAT_DELETE:
            return {
                ...state,
                blockformatid: null
            }
        case BLOCKFORMAT_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case BLOCKFORMAT_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case BLOCKFORMAT_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case BLOCKFORMAT_EDIT_CONTAINER_LOADED:
        case BLOCKFORMAT_EDIT_DATA_LOAD:
            return {
                ...state,
                blockformatid: action.payload[0] ? action.payload[0].blockformatid : 0,
                name: action.payload[0] ? action.payload[0].name : '',
                description: action.payload[0] ? action.payload[0].description : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case BLOCKFORMAT_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case BLOCKFORMAT_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case BLOCKFORMAT_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case BLOCKFORMAT_LIST_CONTAINER_UNLOADED:
        case BLOCKFORMAT_LIST_TABLE_UNLOADED:
        case BLOCKFORMAT_EDIT_CONTAINER_UNLOADED:
        case BLOCKFORMAT_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockFormats.js